module.exports = "<iframe\r\n  *ngIf=\"code\"\r\n  [width]=\"width\"\r\n  [height]=\"height\"\r\n  [src]=\"url\"\r\n  frameborder=\"0\"\r\n  allowfullscreen\r\n></iframe>\r\n\r\n<div *ngIf=\"!code\" [class]=\"'video-empty size-' + size\"></div>"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/youtube-player/youtube-player.component.html
// module id = ./libs/atenea-cms/src/youtube-player/youtube-player.component.html
// module chunks = main